module.exports = __webpack_public_path__ + "static/media/cart.a83a95ac.svg";